import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-add-offramp-capital-allocation',
  templateUrl: './add-offramp-capital-allocation.component.html',
  styleUrls: ['./add-offramp-capital-allocation.component.css']
})
export class AddOfframpCapitalAllocationDialog implements OnInit {
  element: any = {};
  myForm: any;
  isEditMode: boolean = false;
  recordId: string = '';
  currentUserDisplay: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddOfframpCapitalAllocationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    this.recordId = this.element._id || '';

    const loggedInUser = this.userService.getUserDetails();
    this.currentUserDisplay = loggedInUser ? `${loggedInUser.name} (${loggedInUser.email})` : '';

    this.myForm = this.fb.group({
      adminid: [
        this.element.adminid ? (this.element.adminid._id || this.element.adminid) : (loggedInUser ? loggedInUser._id : ''),
        [Validators.required]
      ],
      platform: [this.element.platform || '', [Validators.required]],
      from_currency: [this.element.from_currency || 'USDT', [Validators.required]],
      to_currency: [this.element.to_currency || 'INR', [Validators.required]],
      capital_allocated: [this.element.capital_allocated !== undefined ? this.element.capital_allocated : 0, [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
  }

  saveAllocation() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please fill all required fields', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      ...this.myForm.value,
      _csrf: this.data._csrf
    };

    if (this.isEditMode) {
      formData._id = this.recordId;
      this.offrampService.updateOfframpCapitalAllocation(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to update capital allocation', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update capital allocation', notif);
        }
      );
    } else {
      this.offrampService.createOfframpCapitalAllocation(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to create capital allocation', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to create capital allocation', notif);
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-capital-allocation/add-offramp-capital-allocation/add-offramp-capital-allocation.component.ts